import React, { Component } from 'react';
import { Icon } from '@trlogic/ui-pack';
import LanguageUtil from 'util/LanguageUtil';

class WatchlistAlertCloseHeaderComponent extends Component<Props> {
  public render() {
    return <div className='flex items-center justify-center gap-x-5 text-xl'>{this.getTabs()}</div>;
  }

  private getTabs() {
    const { selectedTab } = this.props;
    const tabs = [
      {
        text: LanguageUtil.get({ id: 'common.label.enterReason', defaultMessage: 'Enter Reason' }),
        icon: 'transaction',
      },
      {
        text: LanguageUtil.get({ id: 'common.label.runAction', defaultMessage: 'Run Action' }),
        icon: 'sidebar-action',
      },
    ];
    return tabs.map((tab, i) => (
      <div
        style={{ padding: '5px 5px 10px 5px' }}
        className={`${selectedTab == i ? 'text-primary opacity-100 border-b-primary border-b-[2px]' : 'text-[#4F4F4F] opacity-20 hover:cursor-not-allowed border-0'} cursor-pointer transition-all duration-300 ease-in-out`}
        key={tab.text}
      >
        <Icon icon={tab.icon} size={20} className='mr-2' />
        {tab.text}
      </div>
    ));
  }
}

interface Props {
  selectedTab: number;
}

export default WatchlistAlertCloseHeaderComponent;
